/** Chat paths that must reach the denied-chat screen before no-workspace onboarding. */
export function isWorkspaceChatPath(pathname: string): boolean {
  return /^\/w\/[^/]+\/chat(?:\/|$)/.test(pathname);
}
